import { Controller, FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import {
  CustomCheckboxField,
  CustomCheckboxFieldProps,
} from '@/components/shared/components/NewContextForms/shared/CustomCheckboxField';

export interface CheckboxFormFieldProps<TFieldValues extends FieldValues>
  extends CustomCheckboxFieldProps<TFieldValues> {
  name: FieldPath<TFieldValues>;
  dummyField?: boolean;
}

export function CheckboxFormField<T extends FieldValues>({
  name,
  dummyField = false,
  ...props
}: CheckboxFormFieldProps<T>) {
  const formControl = useFormContext()?.control;

  if (!formControl || dummyField) return <CustomCheckboxField disabled={true} {...props} />;

  return (
    <Controller
      name={name}
      control={formControl}
      render={({ field, fieldState: { error } }) => (
        <CustomCheckboxField field={field} error={error} disabled={dummyField} {...props} />
      )}
    />
  );
}
